import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';

import { Card, CardHeader } from '../components/Card';
import { PeopleList, PeopleListItem } from '../components/PeopleList';

import { SVGHome, SVGMoneyNote } from '../components/SVG';

export default function Buckets({fuelData, groceriesData}) {
    return (
        <div className='flex flex-col relative px-3 gap-3 body-spacing'>
            <Card>
                <CardHeader heading='You owe' />
                <PeopleList>
                    <PeopleListItem name='Codey Miller' pictureSrc='https://r2.serverbook.app/user-image/5ea1de96671e162844589c840ab3e574-medium.jpg' balance={-46.6} />
                </PeopleList>
            </Card>
            <Card>
                <CardHeader heading='Owes you' />
                <PeopleList>
                    <PeopleListItem name='Julie Gorringe' initials='JG' colour='purple' balance={104.5} />
                </PeopleList>
            </Card>
            <Card>
                <CardHeader heading='Settled' />
                <PeopleList>
                    <PeopleListItem name='Jamie Gorringe' initials='JG' colour='red' balance={0} />
                </PeopleList>
            </Card>
        </div>
    );
}